import { IPaymentState } from "@/core/interfaces/state/paymentState.interface";

const state: IPaymentState = {
  payments: {
    hasNext: false,
    totalRecords: 0,
    pageNumber: 0,
    pageSize: 0,
    totalPages: 0,
    payments: [],
  },
  payment: null,
  isFetchingPayments: false,
  isFetchingPayment: false,
  isCreatingPayment: false,
  isUpdatingBankTransfer: false,
  paymentsByMethods: null,
  systemBanks: [],
  isFetchingSystemBanks: false,
};

export default state;
